class SessionBootstrap {
  constructor({ api, cache, store }) {
    this.api = api
    this.cache = cache
    this.store = store
    this.preloadPromise = null
    this.lastLoadedAt = 0
    this.minReloadIntervalMs = 30 * 1000
  }

  async preload({ force = false } = {}) {
    if (!force && this.preloadPromise) {
      return this.preloadPromise
    }

    if (!force && Date.now() - this.lastLoadedAt < this.minReloadIntervalMs) {
      const cachedProfile = this.cache.getUserProfile()
      return {
        user: cachedProfile || null
      }
    }

    this.preloadPromise = this.runPreload(force).finally(() => {
      this.preloadPromise = null
    })

    return this.preloadPromise
  }

  async runPreload(force) {
    const hasToken = !!localStorage.getItem('token')
    if (!hasToken) {
      return { user: null }
    }

    let user = null

    const requests = [
      this.api.get('api/auth/me'),
      this.api.get('api/auth/settings'),
      this.api.get('api/cards/mine/list'),
      this.api.get('api/payments/subscriptions/mine'),
      this.api.get('api/payments/methods/mine')
    ]

    const [userRes, settingsRes, cardsRes, subscriptionRes, paymentMethodsRes] = await Promise.allSettled(requests)

    if (userRes.status === 'fulfilled' && userRes.value && !userRes.value.error) {
      user = userRes.value.user || null
      if (user) this.cache.setUserProfile(user)
    }

    if (settingsRes.status === 'fulfilled' && settingsRes.value && !settingsRes.value.error) {
      const settings = settingsRes.value.settings || {}
      this.store.state.settings = { ...settings }
      this.cache.setUserSettings(settings)
    }

    if (cardsRes.status === 'fulfilled' && cardsRes.value && !cardsRes.value.error) {
      const cards = cardsRes.value.cards || []
      this.cache.setUserCards(cards)

      const cachedProfile = this.cache.getUserProfile()
      const userName = cachedProfile?.name || cachedProfile?.email || 'Пользователь'
      const userAvatar = cachedProfile?.avatar || ''
      const dashboardData = {
        userName,
        userAvatar,
        myCardsCount: cards.length,
        totalViews: cards.reduce((sum, card) => sum + (card.views || 0), 0),
        recentCards: cards.slice(0, 3),
        subscriptionAvailability: cardsRes.value?.subscription || null
      }
      this.cache.setDashboardData(dashboardData)
    } else if (force) {
      this.cache.remove(this.cache.cacheKeys.DASHBOARD_DATA)
    }

    if (subscriptionRes.status === 'fulfilled' && subscriptionRes.value && !subscriptionRes.value.error) {
      const subscriptions = Array.isArray(subscriptionRes.value.subscriptions)
        ? subscriptionRes.value.subscriptions
        : []
      this.cache.setUserSubscription({
        ...subscriptionRes.value,
        subscription: subscriptions[0] || null,
        subscriptions
      })
    } else if (force) {
      this.cache.remove(this.cache.cacheKeys.USER_SUBSCRIPTION)
    }

    if (paymentMethodsRes.status === 'fulfilled' && paymentMethodsRes.value && !paymentMethodsRes.value.error) {
      const paymentMethods = Array.isArray(paymentMethodsRes.value.paymentMethods)
        ? paymentMethodsRes.value.paymentMethods
        : []
      this.cache.setUserPaymentMethods({
        ...paymentMethodsRes.value,
        paymentMethods
      })
    } else if (force) {
      this.cache.remove(this.cache.cacheKeys.USER_PAYMENT_METHODS)
    }

    this.lastLoadedAt = Date.now()
    return { user }
  }
}

export default SessionBootstrap
